import {
  ClubDetailAction,
  ClubDetailActionType,
  ClubDetailState,
} from "../../types/clubs/clubTypes";
import { ProcessingStatusType } from "../../types/nlsTypes";
import { cloneDeep } from "lodash";

const clubDetailsReducer = (
  state: ClubDetailState,
  action: ClubDetailAction
): ClubDetailState => {
  switch (action.type) {
    case ClubDetailActionType.ClubFetchInit: //'CLUB_FETCH_INIT':
      return { ...state, clubDetailStatus: ProcessingStatusType.pending };
    case ClubDetailActionType.ClubFetchSuccess: //'CLUB_FETCH_SUCCESS':
      return {
        ...state,
        clubDetailStatus: ProcessingStatusType.loaded,
        clubDetail: action.payload,
      };
    case ClubDetailActionType.ClubFetchNotFound: //'CLUB_FETCH_NOTFOUND':
      return { ...state, clubDetailStatus: ProcessingStatusType.notfound };
    case ClubDetailActionType.ClubFetchFailure: // 'CLUB_FETCH_FAILURE':
      return { ...state, clubDetailStatus: ProcessingStatusType.error };
    case ClubDetailActionType.ClubSocialActiveFlip:
      let club = cloneDeep(state.clubDetail);
      let newClubSocialList = club?.ClubSocialLinks!.map((social, index) => {
        if (social.ClubSocialID !== action.socialId) {
          // This isn't the item we care about - keep it as-is
          return social;
        }

        // Otherwise, this is the one we want - return an updated value
        return {
          ...social,
          Active: !social.Active,
        };
      });
      club!.ClubSocialLinks = cloneDeep(newClubSocialList);
      return {
        ...state,
        clubDetail: club,
      };

    default:
      return { ...state };
  }
};

export default clubDetailsReducer;
